export default __webpack_public_path__ + "static/media/topcon-logo.45affc01.svg";